module.exports = __webpack_public_path__ + "static/media/Dot1Impressum.58fa44bf.png";